import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { InventoryService } from '../../../services/inventory.service';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CommonModule } from '@angular/common';
import { gridPageRequest } from '../../../model/common/common.model';
import { AdministratorService } from '../../../services/administrator.service';
import { Warehouse } from '../../../model/administration.model';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-ledger-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './ledger-lookup.component.html',
  styleUrl: './ledger-lookup.component.scss'
})
export class LedgerLookupComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;
  ledger: any[] = [];

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 10,
    id: 0
  }

  warehouseList: Warehouse[] = [];
  selectedWarehouse: any;
  unitLabel: string = ''; 
  loader: boolean = false;



  constructor(private inventoryService: InventoryService, private config: DynamicDialogConfig, private administratorService: AdministratorService) { };

  ngOnInit(): void {
    let ProductCode = this.config.data?.ProductCode;
    this.pageRequest.id = this.config.data?.ProductId;
    this.getWarehouse();
    this.getUnitLabel(); 
  }

  // getLedgerTransaction() {
  //   this.inventoryService.getLedgerTransaction(this.pageRequest).subscribe({
  //     next: (data: any) => {
  //       // console.log(data.productLedger);
  //       this.ledger = data.productLedger;
  //     },
  //     error: error => {
  //       console.error(error);
  //     }
  //   });
  // }

  loadLedgerTransaction(event: any) {
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + event.rows + 5;
    this.getGLByWarehouse();
  }

  getWarehouse() {
    this.administratorService.getAllWarehouse(this.pageRequest).subscribe({
      next: (data: any) => {
        this.warehouseList = data.warehouses as Warehouse[];
        this.selectedWarehouse = this.warehouseList[0];
        this.getGLByWarehouse();
      },
      error: error => {
        console.log(error);
      }
    });
  }

  getGLByWarehouse() {
    if (this.selectedWarehouse) {
      const warehouseId = this.selectedWarehouse.warehouseId;
      this.inventoryService.getLedgerTransactionByWarehouse(this.pageRequest, warehouseId).subscribe({
        next: (data: any) => {
          this.ledger = data.productLedger;
        },
        error: error => {
          console.error(error);
        }
      });
    }
  }

  searchByWarehouse() {
    if (this.selectedWarehouse) {
      const warehouseId = this.selectedWarehouse.warehouseId;
      this.inventoryService.getLedgerTransactionByWarehouse(this.pageRequest, warehouseId).subscribe({
        next: (data: any) => {
          this.ledger = data.productLedger;
          if (this.dt1) {
            this.dt1.first = 0;
          }
        },
        error: error => {
          console.error(error);
        }
      });
    }
  }

  getUnitLabel(): void {
    this.loader = true;
    const appKey = 'unitNameLabel';

    this.inventoryService.getUnitByAppKey(appKey).subscribe({
      next: (response: any) => {
        this.loader = false;
        if (response?.appKeycode === appKey) {
          this.unitLabel = response?.data;
        } else {
          this.unitLabel = 'Unit';
        }
      },
      error: error => {
        console.error('Error fetching Unit Label:', error);
        this.unitLabel = 'Unit';
        this.loader = false;
      }
    });
  }

}
